export default class DeductionsReportRequest {
    shiftWeekCommencing: string;
    approvedOnOrAfter: string;
}